"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CampaignSummaryResponseEntity = exports.SummaryDisplayItemEntity = void 0;
class SummaryDisplayItemEntity {
    display;
    displayName;
    estimatedAudience;
    /** * El coste final por 1 repetición.
     * Sigue siendo la fuente de verdad para cálculos rápidos.
     */
    amountPerBlock;
    /** * NUEVO: El detalle matemático de "por qué" cuesta esto.
     * Vital para mostrar tooltips o facturas detalladas.
     */
    pricingBreakdown;
    discounts;
    haveToPayAdmefee;
    total; // Total acumulado (amountPerBlock * numRepeticiones)
    canSend;
    why;
    warnings;
    dates;
}
exports.SummaryDisplayItemEntity = SummaryDisplayItemEntity;
class CampaignSummaryResponseEntity {
    revision;
    summaryId;
    bookingStrategy;
    userId;
    title;
    canSend;
    content;
    mediaType;
    totalPlays;
    mediaId;
    summaries;
    total;
    discounts;
    metrics;
    dates;
    s3Config;
    hasFounds;
}
exports.CampaignSummaryResponseEntity = CampaignSummaryResponseEntity;
